/**
 * Product comparison field table.
 *
 * This file only defines which SPEC rows are compared. Product values continue
 * to come from the existing Product Specs - Custom section on each product page.
 * Add historical/editorial spellings to aliases instead of duplicating values.
 */
/**
 *  key：字段唯一标识，不能重复。
    label：对比弹窗显示的标题。
    aliases：产品 SPEC 中可能填写的标题名称。系统会依次查找，找不到就显示 N/A。
 */
window.ieGeekProductCompareFields = Object.freeze([
  { key: 'resolution', label: 'Auflösung', aliases: ['Resolution', 'Video Resolution', 'Auflösung', 'Videoauflösung', 'Bildauflösung'] },
  { key: 'connectivity', label: 'Verbindung', aliases: ['Connectivity', 'Network Connection', 'Connection Type', 'Wi-Fi', 'Wireless Technology', 'Verbindung', 'Netzwerkverbindung', 'WLAN', 'Funkverbindung'] },
  { key: 'power_source', label: 'Stromversorgung', aliases: ['Power Source', 'Power Supply', 'Power  Supply', 'Camera Power', 'DC Power', 'Stromversorgung', 'Stromquelle', 'Energieversorgung', 'Akku', 'Batterie'] },
  { key: 'recording_mode', label: 'Aufnahmemodus', aliases: ['Recording Mode', 'Recording', 'Aufnahmemodus', 'Aufnahme', 'Aufzeichnungsmodus', 'Aufzeichnung'] },
  // { key: 'special_features', label: 'Special Features', aliases: ['Special Features', 'Other Smart Features'] },
  // { key: 'category', label: 'Category', aliases: ['Category'] },
  // { key: 'brand', label: 'Brand', aliases: ['Brand', 'Manufacturer'] },
  // { key: 'sku', label: 'SKU', aliases: ['SKU'] },
  // { key: 'description', label: 'Description', aliases: ['Description'] },
  // { key: 'product_type', label: 'Product Type', aliases: ['Product Type'] },
  // { key: 'availability', label: 'Availability', aliases: ['Availability'] },
  // { key: 'price_range', label: 'Price Range', aliases: ['Price Range', 'Price'] }
]);
